import React, { useState } from 'react'
import Icons from '../Icons'

function LayoutGallery(props) {

  console.log("layout gallery ")
    const [selected, setSelected] = useState('');
  return (
 
<div> 
    <button className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex gap-2 m-auto my-auto"  onClick={props.layoutSelected}>    
    + Create New Gallery <Icons.Uploads /> 
  </button>
<div className="flex items-center justify-center gap-8 h-screen">
    
      {/* Horizontal Layout Div */}
      <div
        onClick={() => setSelected('horizontal')}
        className="relative border-2 border-solid hover:border-4 border-blue-300 transition-all duration-300 cursor-pointer"
      >
       
        <div style={{ width: '320px', height:'260px', padding: '10px' }}>Template 1</div>
        {selected === 'horizontal' && (
          <div className="absolute top-0 right-0 p-2">
            {/* Tick Mark Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}
      </div>

      {/* Vertical Layout Div */}
      <div
        onClick={() => setSelected('vertical')}
        className="relative border-2 border-solid hover:border-4 border-blue-300 transition-all duration-300 cursor-pointer"
      >
       <div style={{ width: '320px', height:'260px', padding: '10px' }}>Template 2</div>
        {selected === 'vertical' && (
          <div className="absolute top-0 right-0 p-2">
            {/* Tick Mark Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}
      </div>
    </div>

    </div>
  )
}

export default LayoutGallery